import React from "react";
import { createRoot } from "react-dom/client";
import "@kui/foundations-react/base.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

// Kaizen UI color + density theme (light, same as Registration UI)
document.documentElement.classList.add("nv-light", "nv-density-standard");

createRoot(document.getElementById("root")).render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
